export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-24 md:pt-28">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 pb-14 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:pb-20">
        <div>
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#e85d3f]/20 bg-[#e85d3f]/10 px-4 py-1.5 text-xs font-semibold text-[#e85d3f]">
            <i className="ri-fire-line text-sm"></i>
            今晚多部好剧更新 · 在线抢先看最新剧情
          </div>

          <h1 className="font-serif-sc text-3xl font-black leading-[1.15] tracking-tight text-[#26201a] md:text-5xl">
            连续剧追更站，
            <br className="hidden md:block" />
            追更不迷路 <span className="text-[#e85d3f]">今晚看什么</span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-7 text-[#6f655a] md:text-base">
            从开播到高潮全程无缝衔接，每集都有新「瓜」落地。从今晚最新剧情、热播榜单到追更日历，
            <span className="font-semibold text-[#26201a]">55吃瓜</span>
            帮你把想看与正在追的剧一次理清，更新提醒快人一步，让你永远走在吃瓜最前线。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#tonight"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[#e85d3f] px-7 py-3.5 text-sm font-semibold text-white transition-all hover:bg-[#c9431f]"
            >
              今晚抢先看 <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#calendar"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-[#26201a]/15 bg-white/70 px-7 py-3.5 text-sm font-semibold text-[#26201a] transition-colors hover:border-[#e85d3f] hover:text-[#e85d3f]"
            >
              查看本周日历
            </a>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-3 text-[#a3988a]">
            <div className="flex items-center gap-2">
              <span className="font-serif-sc text-2xl font-black text-[#26201a]">86</span>
              <span className="text-xs">部热播进行中</span>
            </div>
            <div className="h-8 w-px bg-[#26201a]/10"></div>
            <div className="flex items-center gap-2">
              <span className="font-serif-sc text-2xl font-black text-[#26201a]">24h</span>
              <span className="text-xs">更新动态刷新</span>
            </div>
            <div className="h-8 w-px bg-[#26201a]/10"></div>
            <div className="flex items-center gap-2">
              <span className="font-serif-sc text-2xl font-black text-[#26201a]">6</span>
              <span className="text-xs">大剧集分类</span>
            </div>
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-md">
          <div className="absolute -left-6 -top-6 h-40 w-40 rounded-full bg-[#f3ecdf]"></div>
          <div className="absolute -bottom-8 -right-4 h-48 w-48 rounded-full bg-[#e85d3f]/10"></div>

          <div className="relative rounded-3xl bg-gradient-to-br from-[#e85d3f] to-[#c9431f] p-1.5">
            <div className="overflow-hidden rounded-[1.25rem]">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20chinese%20drama%20themed%20collage%20poster%20with%20silk%20lanterns%20and%20paper%20cutouts%20silhouette%2C%20warm%20coral%20and%20cream%20palette%2C%20cinematic%20editorial%20mood%2C%20high%20detail%20artwork&width=900&height=1100&seq=hero-main-01&orientation=portrait"
                alt="55吃瓜连续剧追更站 今晚最新剧情抢先看"
                className="h-auto w-full object-cover"
              />
            </div>
          </div>

          <div className="absolute -left-5 bottom-8 flex items-center gap-3 rounded-2xl bg-white/95 px-4 py-3 shadow-sm">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#f3ecdf] text-[#e85d3f]">
              <i className="ri-play-circle-line text-lg"></i>
            </span>
            <div>
              <p className="text-xs font-semibold text-[#26201a]">今晚更新 · 暗河长明</p>
              <p className="text-[11px] text-[#a3988a]">第 28 集 · 大结局</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-y border-[#26201a]/10 bg-white/60">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-8 gap-y-2 px-4 py-3 text-xs text-[#a3988a] md:px-6">
          <span className="flex items-center gap-1.5 font-semibold text-[#26201a]">
            <i className="ri-flashlight-line text-[#e85d3f]"></i> 正在热搜
          </span>
          {['长安十二时辰·续 大结局', '半夏CP 窗台告白', '白夜迷局 第9集', '我家那口锅 更新'].map((t) => (
            <a key={t} href="#news" className="flex items-center gap-1.5 transition-colors hover:text-[#e85d3f]">
              <i className="ri-price-tag-3-line"></i>
              {t}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}